import { Product } from "@/interfaces/domain/Product";
import { api } from "@/services/api";

export async function getProductByIdRequest(id: string) {
  const { data } = await api.get<Product>(`/produtos/${id}`);
  return data;
}
